import React from 'react';
import { formatUTCDate } from '../../utils/dateUtils';
import { useFollowUpReminders } from '../../hooks/useFollowUpReminders';
import { Clock } from 'lucide-react';

interface NextFollowUpProps {
  contactId: string;
}

export default function NextFollowUp({ contactId }: NextFollowUpProps) {
  const { reminders, loading } = useFollowUpReminders(contactId);

  if (loading) {
    return <div className="text-gray-400">Loading...</div>;
  }

  // Find the next uncompleted reminder
  const nextReminder = reminders
    .filter(r => !r.completed)
    .sort((a, b) => new Date(a.due_date).getTime() - new Date(b.due_date).getTime())[0];

  if (!nextReminder) {
    return <span className="text-gray-400">No follow-ups</span>;
  }

  const dueDate = new Date(nextReminder.due_date);
  const isOverdue = dueDate < new Date();

  return (
    <div className="flex items-center text-sm">
      <Clock className="w-4 h-4 mr-2 text-gray-400" />
      <span className={isOverdue ? 'text-red-400' : 'text-gray-400'}>
        {formatUTCDate(dueDate.toISOString())}
      </span>
    </div>
  );
}